module.exports = __webpack_public_path__ + "static/logo_tg-a1857213c1ad61763d9daf7d7d03b7e1.svg";